import {
  PretOkraglyAlu,
  PretKwadrat,
  PretSzescio,
  Plaskownik,
  Rura,
  ProfilZamknietyKwadratowy,
  KatownikiRownoramienne,
  Katowniki,
  Ceowniki,
  Blachy,
  Dwuteownik,
} from "../AluWzory";
import ProfilZamkniety from "../AluWzory/ProfilZamkniety";
import gestoscalu from "../../data/gestoscalu.json";
import gestoscstali from "../../data/gestoscstali.json";
import gestoscnierdzewnej from "../../data/gestoscnierdzewnej.json";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Select, SelectItem } from "@nextui-org/select";
const AluItemDetail = ({
  item,
  activeComponent,
  density,
  setDensity,
  onWeightChange,
}) => {
  const handleChangeAluDensity = (e) => {
    setDensity(gestoscalu[e.target.value].value);
  };

  const handleChangeStalDensity = (e) => {
    setDensity(gestoscstali[e.target.value].value);
  };

  const handleChangeStalNDensity = (e) => {
    setDensity(gestoscnierdzewnej[e.target.value].value);
  };

  return (
    <>
      <h2 className="itemName">{item.name}</h2>
      <div className="topItem">
        <div className="topItem-inner-container">
          <LazyLoadImage
            src={item.render}
            alt={item.name}
            effect="blur"
            className="block w-full h-60 sm:h-60 object-contain p-2 sm:p-2"
            height={240}
          />
        </div>
        <div className="topItemRight">
          <div className="formArea">
            {item.id === 8 ? (
              ""
            ) : (
              <label className="label w-full" style={{ textTransform: "uppercase" }}>
                {activeComponent === "AluList" ? "" : ""}
                {activeComponent === "stal" ? "" : ""}
                {activeComponent === "StalList" ? "" : ""}
                {activeComponent === "AluList" && (
                  <Select
                    name="gestosc"
                    onChange={(e) => handleChangeAluDensity(e)}
                    placeholder="Wybierz gęstość aluminium"
                    aria-label="aluminium"
                    classNames={{
                      base: "", 
                      mainWrapper: "",
                      trigger:
                        "min-h-9 h-9 custom-box-select w-full",
                    }}
                  >
                    {gestoscalu.map((g) => (
                      <SelectItem key={g.id} value={g.value}>
                        {g.name}
                      </SelectItem>
                    ))}
                  </Select>
                )}
                {activeComponent === "stal" && (
                  <Select
                    name="gestosc"
                    onChange={(e) => handleChangeStalDensity(e)}
                    placeholder="Wybierz gęstość stali"
                    aria-label="stal"
                    classNames={{
                      base: "",
                      mainWrapper: "",
                      trigger:
                        "min-h-9 h-9 custom-box-select w-full",
                    }}
                  >
                    {gestoscstali.map((gs) => (
                      <SelectItem key={gs.id} value={gs.value}>
                        {gs.name}
                      </SelectItem>
                    ))}
                  </Select>
                )}
                {activeComponent === "StalList" && (
                  <Select
                    name="gestosc"
                    onChange={(e) => handleChangeStalNDensity(e)}
                    placeholder="Wybierz gęstość stali nierdz."
                    aria-label="stal nierdzewna"
                    classNames={{
                      base: "",
                      mainWrapper: "",
                      trigger:
                        "min-h-9 h-9 custom-box-select w-full",
                    }}
                  >
                    {gestoscnierdzewnej.map((gn) => (
                      <SelectItem key={gn.id} value={gn.value}>
                        {gn.name}
                      </SelectItem>
                    ))}
                  </Select>
                )}
              </label>
            )}
          {item.id === 10 ? (
            <PretOkraglyAlu density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 9 ? (
            <PretKwadrat density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 11 ? (
            <PretSzescio density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 12 ? (
            <Plaskownik density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 3 ? (
            <Rura density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 1 ? (
            <ProfilZamknietyKwadratowy
              density={density}
              onWeightChange={onWeightChange}
            />
          ) : null}
          {item.id === 2 ? (
            <ProfilZamkniety
              density={density}
              onWeightChange={onWeightChange}
            />
          ) : null}
          {item.id === 4 ? (
            <KatownikiRownoramienne
              density={density}
              onWeightChange={onWeightChange}
            />
          ) : null}
          {item.id === 5 ? (
            <Katowniki density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 6 ? (
            <Ceowniki density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 7 ? (
            <Blachy density={density} onWeightChange={onWeightChange} />
          ) : null}
          {item.id === 8 ? (
            <Dwuteownik onWeightChange={onWeightChange} />
          ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default AluItemDetail;